// extracted by extract-css-chunks-webpack-plugin
module.exports = {"small-input":"_1Hwpxb"};